var map = {
	"./akshara.png": 8381,
	"./amnon.png": 8899,
	"./archersDoom.png": 1959,
	"./architecture.png": 2331,
	"./arnold.png": 8058,
	"./ashish.png": 3454,
	"./axeMastery.png": 9809,
	"./bard.png": 2627,
	"./battleRituals.png": 7110,
	"./battleTrance.png": 9819,
	"./batu.png": 3400,
	"./blackArmy.png": 9278,
	"./bloodlines.png": 9119,
	"./bogdan.png": 9927,
	"./bracer.png": 7439,
	"./bracing.png": 5312,
	"./bushido.png": 7104,
	"./callToArms.png": 5104,
	"./camelRiding.png": 5557,
	"./cataphractsLegacy.png": 7075,
	"./cavalryBane.png": 7182,
	"./chivalry.png": 8946,
	"./compositeBowMastery.png": 7122,
	"./conscription.png": 3187,
	"./cropsRotation.png": 1559,
	"./devastatingCharge.png": 3832,
	"./dulna.png": 8724,
	"./egon.png": 5413,
	"./einar.png": 1877,
	"./elaine.png": 4212,
	"./elephantBreeding.png": 9103,
	"./fencing.png": 3294,
	"./fletching.png": 6300,
	"./forging.png": 7636,
	"./gasher.png": 5922,
	"./generic.png": 9015,
	"./gillnetting.png": 9769,
	"./greataxeMastery.png": 2456,
	"./greatswordMastery.png": 2253,
	"./halberdMastery.png": 9803,
	"./harald.png": 4172,
	"./haru.png": 8480,
	"./hashashinsOrder.png": 1024,
	"./heavyPlow.png": 723,
	"./herbalMedicine.png": 9028,
	"./hireResearcher1.png": 8349,
	"./hireResearcher2.png": 7670,
	"./honorCode.png": 8691,
	"./hordePower.png": 4071,
	"./horsemanship.png": 4173,
	"./husbandry.png": 398,
	"./imhotep.png": 8196,
	"./isidur.png": 6636,
	"./jousts.png": 9116,
	"./katanaMastery.png": 7697,
	"./kioshi.png": 7421,
	"./longbowMastery.png": 355,
	"./mahoutTradition.png": 6878,
	"./martialArts.png": 8260,
	"./masonry.png": 7253,
	"./matchlock.png": 8074,
	"./mathematics.png": 278,
	"./menar.png": 5961,
	"./mercenaries.png": 8392,
	"./miklos.png": 955,
	"./naginataMastery.png": 7996,
	"./obliterate.png": 9383,
	"./odinsFury.png": 9883,
	"./otto.png": 904,
	"./paladinsFate.png": 7588,
	"./pathFinder.png": 5831,
	"./perfectBalance.png": 4691,
	"./philosophy.png": 703,
	"./pikeMastery.png": 6720,
	"./radovan.png": 3999,
	"./rampage.png": 7709,
	"./rangerTraining.png": 1967,
	"./rifling.png": 5239,
	"./rogue.png": 8610,
	"./ronan.png": 5032,
	"./saberMastery.png": 8156,
	"./sailo.png": 8042,
	"./samama.png": 3414,
	"./saw.png": 1279,
	"./scimitarMastery.png": 813,
	"./shaftMining.png": 4396,
	"./shieldMastery.png": 226,
	"./squires.png": 9212,
	"./stirrup.png": 7021,
	"./superiorHorses.png": 5673,
	"./szlachta.png": 2620,
	"./thumbRing.png": 2438,
	"./ultamar.png": 7446,
	"./unknown.png": 9026,
	"./writing.png": 7896,
	"./yariMastery.png": 5512,
	"./yasin.png": 2868,
	"./yoshiko.png": 412,
	"./yumiMastery.png": 7263,
	"./zazen.png": 974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9553;